import React from 'react';
import Select from '../Select';

const autocomplete = () => {
  if (!window.google) throw new Error('Cannot find google api');
  if (!window.google.maps.places) throw new Error('Cannot find google places api');

  return new window.google.maps.places.AutocompleteService();
};

const findItems = text =>
  new Promise(resolve => {
    const input = text || '';
    if (input.length === 0) {
      resolve([]);
      return;
    }

    autocomplete().getPlacePredictions({ input, types: ['geocode'] }, (predictions, status) => {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
        resolve([]);
      } else {
        resolve(
          predictions.map(p => ({
            placeId: p.place_id,
            value: p.place_id,
            label: p.description,
            main: p.structured_formatting.main_text,
            secondary: p.structured_formatting.secondary_text,
          })),
        );
      }
    });
  });

const AddressInput = props => {
  return <Select items={findItems} {...props} />;
};

export default AddressInput;
